/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Offline_TitleInputs */



/**
* | output |
* | --- |
* | "Signed in, offline" |
*
* @param {Profile_Offline_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_offline_title = /** @type {((inputs?: Profile_Offline_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Offline_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connecté, hors ligne")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sesión iniciada, sin conexión")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sessão iniciada, offline")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accesso effettuato, offline")
	return /** @type {LocalizedString} */ ("Signed in, offline")
});